module.exports = __webpack_public_path__ + "img/world-page-bottom-circle.b731d3a1.svg";